"use client";

import * as X from "@/ui";

import { HeroSection } from "./1.Hero";
import { TravelerSection } from "./2.Traveler";
import { AdvantagesSection } from "./3.Advantages";
import { CustomersSection } from "./4.Customers";
import { TestimonialsSection } from "./5.Testimonials";
import { FeaturedFaqSection } from "./6.FeaturedFaq";
import { LearnMoreSection } from "./7.LearnMore";
import { useRetailerHomePage } from "@/providers/strapi/content/types/singleTypes/retailer-home-page";



export function RetailHomeClient(props: X.PageProps) {
  const [downloadModalOpen, setDownloadModalOpen] = X.useState(false);
  const travelerCard = useRetailerHomePage('travelerCard');
  const satisfactionCard = useRetailerHomePage('satisfactionCard');
  const ratingCard = useRetailerHomePage('ratingCard');
  const testimonials = useRetailerHomePage('testimonials');
  return (
    <>
      <X.MainLayout locale={props.locale}>
        <HeroSection locale={props.locale} />
        <TravelerSection
          locale={props.locale}
          onDownloadApp={() => setDownloadModalOpen(true)}
          travelerCard={travelerCard}
          satisfactionCard={satisfactionCard} />
        <AdvantagesSection locale={props.locale} />
        <CustomersSection locale={props.locale} />
        <TestimonialsSection locale={props.locale} ratingCard={ratingCard} testimonials={testimonials} />
        <FeaturedFaqSection locale={props.locale} />
        <LearnMoreSection locale={props.locale} />
      </X.MainLayout>

      <X.DownloadModal
        locale={props.locale}
        isOpen={downloadModalOpen}
        onClose={() => setDownloadModalOpen(false)}
      />
    </>
  );
}
